import { StyledCard } from "@components";
import { Card, Divider, Progress, Select, Tag } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import StuckBar from "./Stuck";
import { theme } from "@utils";
import { IChartCoupon, IClinicCoupon, IClinicVisualData, ICouponVisualData } from "@interfaces";
import { region_towship } from "@configs";
interface IProps {
  coupon: {
    data: ICouponVisualData | null;
    loading: boolean;
  };
}
export const CouponCount = ({ coupon: { data, loading } }: IProps) => {
  const { t } = useTranslation();

  return (
    <StyledCard loading={loading}>
      <header>
        <div>
          <p>{t("page.coupon")}</p>
          <h5>{t("page.today_coupon_redeem_user_count")}</h5>
        </div>
      </header>
      <Divider />
      <div className="item flex">
        <p>{t("page.coupon_generated")}</p>
        <Tag color={theme.colors.orange}>{data?.couponInfo?.generatedCount}</Tag>
      </div>
      <Divider />
      <div className="item flex">
        <p>{t("page.coupon_redeemed")}</p>
        <Tag color={theme.colors.green}>{data?.couponInfo?.redemeedCount}</Tag>
      </div>
      <Progress
        percent={Math.floor(
          ((data?.couponInfo?.redemeedCount || 0) / (data?.couponInfo?.generatedCount || 0)) *
            100 || 0
        )}
        strokeColor={theme.colors.green}
      />
      <p className="progress-label">
        {t("page.number_fo_coupon", {
          number: data?.couponInfo?.redemeedCount,
          numbers: data?.couponInfo?.generatedCount,
        })}
      </p>
      <Divider />
      <div className="item flex">
        <p>{t("page.coupon_cancel")}</p>
        <Tag color={theme.colors.expired}>{data?.couponInfo?.cancelCount}</Tag>
      </div>
      <Progress
        percent={
          ((data?.couponInfo?.cancelCount || 0) / (data?.couponInfo?.generatedCount || 0)) * 100 ||
          0
        }
        strokeColor={theme.colors.expired}
      />
      <p className="progress-label">
        {t("page.number_fo_coupon", {
          number: data?.couponInfo?.cancelCount,
          numbers: data?.couponInfo?.generatedCount,
        })}
      </p>
    </StyledCard>
  );
};
interface IStackBar {
  clinic: {
    data: IClinicCoupon[] | null;
    loading: boolean;
  };
  region?: string;
  handleFilterRegion: (value: string) => void;
}

export const CouponChart = ({
  clinic: { data, loading },
  region,
  handleFilterRegion,
}: IStackBar) => {
  const [load, setLoad] = useState(false);
  const { t } = useTranslation();
  useEffect(() => {
    setLoad(true);

    setTimeout(() => {
      setLoad(false);
    }, 2000);
  }, []);

  const handleSelect = (value: any) => {
    handleFilterRegion(value);
  };
  return (
    <StyledCard loading={loading} minwidth={500}>
      <header>
        <div>
          <p>{t("page.coupon")}</p>
          <h5>{t("page.geographic_describution")}</h5>
        </div>
        <Select placeholder="select region" onChange={handleSelect} value={region}>
          {Object.keys(region_towship).map((item) => (
            <Select.Option value={item} key={item}>
              {t(`page.${item}`)}
            </Select.Option>
          ))}
        </Select>
      </header>
      <Divider />
      <div className="chart">
        <StuckBar data={data} />
      </div>
    </StyledCard>
  );
};
